import createIcon from '../../createIcon';

/**
 * @component @name FireExtinguisher
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOC41SDE4VjE5LjVDMTggMjAuNiAxNy4xIDIxLjUgMTYgMjEuNUgxMEM4LjkgMjEuNSA4IDIwLjYgOCAxOS41VjE4LjVaTTggMTcuNUgxOFYxMi41SDhWMTcuNVpNMTggMi41VjguNUwxNC44NSA3Ljg0QzE0Ljg0IDcuODQgMTQuODQgNy44NSAxNC44MyA3Ljg2QzE2LjM4IDguNDggMTcuNTUgOS44NCAxNy45IDExLjVIOC4xQzguNDQgOS44NCA5LjYyIDguNDggMTEuMTcgNy44NkMxMC44NCA3LjYgMTAuNTcgNy4yOCAxMC4zNyA2LjkxTDYgNlY1TDEwLjM3IDQuMDlDMTAuODcgMy4xNSAxMS44NiAyLjUgMTMgMi41QzEzLjcgMi41IDE0LjM0IDIuNzUgMTQuODUgMy4xNkwxOCAyLjVaTTE0IDUuNUMxMy45NyA0LjkxIDEzLjU1IDQuNSAxMyA0LjVDMTIuNDUgNC41IDEyIDQuOTUgMTIgNS41QzEyIDYuMDUgMTIuNDUgNi41IDEzIDYuNUMxMy41NSA2LjUgMTQgNi4wNSAxNCA1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FireExtinguisher = createIcon('FireExtinguisher', [
  [
    'path',
    {
      d: 'M8 18.5H18V19.5C18 20.6 17.1 21.5 16 21.5H10C8.9 21.5 8 20.6 8 19.5V18.5ZM8 17.5H18V12.5H8V17.5ZM18 2.5V8.5L14.85 7.84C14.84 7.84 14.84 7.85 14.83 7.86C16.38 8.48 17.55 9.84 17.9 11.5H8.1C8.44 9.84 9.62 8.48 11.17 7.86C10.84 7.6 10.57 7.28 10.37 6.91L6 6V5L10.37 4.09C10.87 3.15 11.86 2.5 13 2.5C13.7 2.5 14.34 2.75 14.85 3.16L18 2.5ZM14 5.5C13.97 4.91 13.55 4.5 13 4.5C12.45 4.5 12 4.95 12 5.5C12 6.05 12.45 6.5 13 6.5C13.55 6.5 14 6.05 14 5.5Z',
      key: '1v5flr',
    },
  ],
]);

export default FireExtinguisher;
